export default __webpack_public_path__ + "static/media/black_unicorn.3b35f795.png";